import * as React from "react";

interface IProps {
    text: string;
    fontSize?: number;
}

export const TextContainer = (props: IProps) => {
    const style = {
        border: "1px dashed #434175",
        backgroundColor: "#F5F6FA",
        height: 47,
        width: "100%",
        color: "#434175",
        fontSize: props.fontSize ? props.fontSize : 18,
        display: "flex",
        padding: 5,
    };
    return (
        <div style={style} className="flex-center-row-center-column">
            {props.text}
        </div>
    );
};

export default TextContainer;
